<div class="fixed transform z-2" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>
<div class=" px-0 pb-0">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten">
      <div class="btn"><a>Thrombolytic Case Analysis</a></div>
    </div>
  </div>
</div>
<div>
  <p-table #dt [value]=" tPACaseAnalysisList" [columns]="tPACaseAnalysisList" [rows]="rows" 
    styleClass="p-datatable-striped p-datatable-gridlines" [paginator]="true" sortMode="multiple"
    [rowHover]="true" dataKey="Id" [totalRecords]="totalRecords"
    [lazy]="true" (onLazyLoad)="lazyLoadSchedules($event)" [resizableColumns]="true" columnResizeMode="expand" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"
     [rowsPerPageOptions]="[10,15,25,50,totalRecords]">
    <ng-template pTemplate="header">
      <tr>
        <th class="facilityWidth" pResizableColumn>
          Facility
        </th>
        <th pSortableColumn="TeleCareCase#" pResizableColumn>
          TeleCare Case #
          <p-sortIcon field="TeleCareCase#"></p-sortIcon>
        </th>
        <th pSortableColumn="Date" pResizableColumn>
          Date
          <p-sortIcon field="Date"></p-sortIcon>
        </th>
        <th pSortableColumn="ProcessEMSWIIPED" pResizableColumn>
          Process (EMS / WI/ IP / ED)
          <p-sortIcon field="ProcessEMSWIIPED"></p-sortIcon>
        </th>
        <th pSortableColumn="DTNMin" pResizableColumn>
          DTN (Min)
          <p-sortIcon field="DTNMin"></p-sortIcon>
        </th>
        <th *ngIf="!roleForFacility" style="width: 25rem;" pSortableColumn="ThrombolyticDelayNotes" pResizableColumn>
          Thrombolytic Delay Notes
          <p-sortIcon field="ThrombolyticDelayNotes"></p-sortIcon>
        </th>
        <th class="long-column" style="width: 25rem;" pSortableColumn="QPSAnalysis" pResizableColumn>
          QPS Analysis
          <p-sortIcon field="QPSAnalysis"></p-sortIcon>
        </th>
        <th *ngIf="!roleForFacility" class="long-column" style="width: 25rem;" pSortableColumn="MedicalDirectorAnalysis" pResizableColumn>
          Medical Director Analysis
          <p-sortIcon field="MedicalDirectorAnalysis"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tPACaseAnalysisList>
      <tr>
        <td class="long-column">{{tPACaseAnalysisList.Facility}}</td>
        <td>
          <ng-container *ngIf="RoleName.toLowerCase().includes('facility')">{{tPACaseAnalysisList.CaseNumber}}</ng-container>
          <ng-container *ngIf="!RoleName.toLowerCase().includes('facility')">
            <a [href]="accessCase + tPACaseAnalysisList.Case_Key" target="_blank">{{tPACaseAnalysisList.CaseNumber}}</a>
          </ng-container>
        </td>
        <td>{{tPACaseAnalysisList.Date}}</td>
        <td>{{tPACaseAnalysisList.Process}}</td>
        <td>{{tPACaseAnalysisList.DTN}}</td>
        <td *ngIf="!roleForFacility" class="long-column">{{tPACaseAnalysisList.tPAdelaynotes}}</td>
        <td class="long-column">{{tPACaseAnalysisList.QPSanalysis}}</td>
        <td *ngIf="!roleForFacility" class="long-column">{{tPACaseAnalysisList.MedicalDirectorAnalysis}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <h5 *ngIf="totalRecords==0" class="text-center create-roles">
          <b> No records found</b>
        </h5>
      </tr>
    </ng-template>
  </p-table>
  <div class="md:col-12">
    <span class="tableRefreshTime">
      Grid Last Refreshed at {{analyzeService._currentDate}} - {{analyzeService._currentTime}}
    </span>
  </div>
</div>
